module.exports = __webpack_public_path__ + "static/media/FangDiChan1.12a1fa8c.png";